const config = useRuntimeConfig();
const floristUnitCountryCode = config.public.unitCountryCode;
export const isFrenchFlorist: boolean = floristUnitCountryCode === 'FR';
export const isItalianFlorist: boolean = floristUnitCountryCode === 'IT';
export const isSpanishFlorist: boolean = floristUnitCountryCode === 'ES';
export const isPortugueseFlorist: boolean = floristUnitCountryCode === 'PT';
export const isDanishFlorist: boolean = floristUnitCountryCode === 'DK';
export const isAmericanFlorist: boolean = floristUnitCountryCode === 'US';
export const isSEUFlorist = computed(() => {
  return ['IT', 'ES', 'PT'].includes(floristUnitCountryCode);
});

export const getLocale = () => {
  switch (floristUnitCountryCode) {
    case 'FR':
      return 'fr-FR';
    case 'IT':
      return 'it-IT';
    case 'ES':
      return 'es-ES';
    case 'PT':
      return 'pt-PT';
    case 'DK':
      return 'da-DK';
    default:
      return 'en-US';
  }
};
